const API_BASE = '/api';

let accessToken = null;
let refreshToken = null;
let drillInHotelId = null;

// Load tokens from storage on init
try {
  accessToken = localStorage.getItem('leadiox-access-token');
  refreshToken = localStorage.getItem('leadiox-refresh-token');
} catch {}

export function setDrillInHotel(hotelId) { drillInHotelId = hotelId; }
export function clearDrillInHotel() { drillInHotelId = null; }

export function setTokens(access, refresh) {
  accessToken = access;
  refreshToken = refresh;
  try {
    if (access) localStorage.setItem('leadiox-access-token', access);
    else localStorage.removeItem('leadiox-access-token');
    if (refresh) localStorage.setItem('leadiox-refresh-token', refresh);
    else localStorage.removeItem('leadiox-refresh-token');
  } catch {}
}

export function clearTokens() {
  accessToken = null;
  refreshToken = null;
  try {
    localStorage.removeItem('leadiox-access-token');
    localStorage.removeItem('leadiox-refresh-token');
    localStorage.removeItem('leadiox-user');
  } catch {}
}

async function refreshAccessToken() {
  if (!refreshToken) throw new Error('No refresh token');
  const res = await fetch(`${API_BASE}/auth/refresh`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refreshToken }),
  });
  if (!res.ok) {
    clearTokens();
    window.location.href = '/login';
    throw new Error('Session expired');
  }
  const data = await res.json();
  setTokens(data.accessToken, data.refreshToken);
  return data.accessToken;
}

export async function api(path, options = {}) {
  const { method = 'GET', body, params } = options;

  let url = `${API_BASE}${path}`;
  if (params) {
    const qs = new URLSearchParams(params).toString();
    if (qs) url += `?${qs}`;
  }

  const headers = { 'Content-Type': 'application/json' };
  if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`;
  if (drillInHotelId) headers['X-Drill-In-Hotel'] = drillInHotelId;

  const fetchOpts = { method, headers };
  if (body && method !== 'GET') fetchOpts.body = JSON.stringify(body);

  let res = await fetch(url, fetchOpts);

  // Auto-refresh on 401
  if (res.status === 401 && refreshToken) {
    try {
      const newToken = await refreshAccessToken();
      headers['Authorization'] = `Bearer ${newToken}`;
      res = await fetch(url, { ...fetchOpts, headers });
    } catch {
      throw new Error('Session expired');
    }
  }

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(err.error || `HTTP ${res.status}`);
  }

  return res.json();
}

// Convenience methods
export const get = (path, params) => api(path, { params });
export const post = (path, body) => api(path, { method: 'POST', body });
export const put = (path, body) => api(path, { method: 'PUT', body });
export const del = (path) => api(path, { method: 'DELETE' });
